module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Pump.js"));
	}, "Pump");
}